
import { Component, Vue } from 'vue-property-decorator'
import VueJSModal from 'vue-js-modal'
import eventBus from '@/plugins/eventBus'
import { OrderModel } from '@/store/models/OrderModel'
import { CartModel } from '@/store/models/CartModel'
import { UserModel } from '@/store/models/UserModel'

Vue.use(VueJSModal)
import STextField from '@/components/STextField.vue'
import SButton from '@/components/SButton.vue'
import { addressValidation } from '@/plugins/popups'
import { envConfiguration } from '@/plugins/globalStaticDatas'

@Component({
  components: { STextField, SButton },
})
export default class CheckoutModal extends Vue {
  cart: CartModel = CartModel.getInstance()
  order: OrderModel = OrderModel.getInstance()
  user: UserModel = UserModel.getInstance()
  total: Number = 0
  date: Date = new Date()
  isAddressEmpty: boolean = false
  disableOrderBtn: boolean = false
  showAddressInput: boolean = false
  envConfigurations: object = envConfiguration

  payments = [
    {
      name: 'Cash',
    },
  ]
  request: any = {
    address_id: 0,
    address: '',
    date: this.date.toISOString().slice(0, 10),
    latitude: 0,
    longitude: 0,
    payment_method: 'Cash',
    details: [],
    notes: '',
  }

  mounted() {
    eventBus.$on('checkout-modal', (checkoutProduct, checkoutTotal, checkoutDetails) => {
      this.payments = checkoutDetails[0].payment_methods
      console.log(this.payments, 'pay')
      this.$modal.show('checkout-modal')
      this.request.details = this.cart.items.map((product: any) => ({
        product_id: product.productId,
        product_price: product.price,
        amount: product.quantity,
        measurement_unit_id: 1,
      }))
    })
    eventBus.$on('close_checkout_modal', () => {
      this.$modal.hide('checkout-modal')
      this.isAddressEmpty = false
    })
  }
  beforeOpen() {}
  openedModal(): void {
    this.isAddressEmpty = false
    this.showAddressInput = false

    if (!this.user.isLogged()) {
      // @ts-ignore
      document.getElementsByClassName('select-address')[0].style.display = 'none'
      this.showAddressInput = true
      return
    }

    this.user.load(false, () => {
      if (this.user.isLogged() && this.user.addresses && this.user.addresses.length !== 0) {
        this.request.address_id = (this.user.addresses.find((add: any) => add.is_default) || {}).id || 0
      }
      if (this.user && this.user.addresses && this.user.addresses.length === 0) {
        this.showAddressInput = true
      }

      this.isAddressEmpty = false
      if (this.request.address_id !== 0) {
        this.showAddressInput = false
      }
    })
  }
  showAddressInputField() {
    this.showAddressInput = !this.showAddressInput
    if (this.user.addresses.length !== 0) {
      this.request.address_id = this.user.addresses.find((add: any) => add.is_default).id || 0
    } else return
    if (this.showAddressInput) {
      this.request.address_id = 0
      this.isAddressEmpty = false
    }
  }

  doOrder() {
    this.disableOrderBtn = true
    this.isAddressEmpty = true

    if (!this.user.isLogged()) {
      this.disableOrderBtn = false
      this.$modal.hide('checkout-modal')
      eventBus.$emit('user:start-login', (user: any) => {
        this.$modal.show('checkout-modal')
      })
      return
    }
    if (this.request.address_id !== 0) {
      this.isAddressEmpty = true
      this.disableOrderBtn = true
      this.order.postOrder(
        this.request,
        () => {
          this.disableOrderBtn = false
        },
        () => {
          this.disableOrderBtn = false
        }
      )
      return
    }
    if (this.request.address === '') {
      this.isAddressEmpty = true
      setTimeout(() => {
        this.disableOrderBtn = false
      }, 100)
    } else {
      if (this.request.address.length < 15) {
        addressValidation()
        this.disableOrderBtn = false
      }
      this.order.postOrder(
        this.request,
        () => {
          this.disableOrderBtn = false
          this.request.address = ''
        },
        () => {
          this.disableOrderBtn = false
          this.request.address = ''
        }
      )
    }
  }

  removeErrorStyle() {
    if (this.request.address_id !== 0) {
      this.showAddressInput = false
      this.request.address = ''
      document.getElementById('select-label').classList.remove('error-label')
      document.getElementById('address-select').classList.remove('error-select')
    }
  }
}
